<template>
  <div style="text-align: right;" v-if="!$store.getters.getUserGroupAlerts.show_limited_data_count">
        <!--<div>
            Total <b>{{dataProps.total}}</b> Records
        </div>-->
        <el-pagination
            v-if="hideTotal"
            background
            small
            @size-change="handleSizeChange"
            :current-page.sync="dataProps.page_number"
            @current-change="$emit('navigateButton')"
            @prev-click="$emit('navigateButton')"
            @next-click="$emit('navigateButton')"
            :page-size.sync="limit"
            layout="sizes, prev, pager, next"
            :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
            :total="dataProps.total">
        </el-pagination>
        <el-pagination
            v-else
            background
            small
            @size-change="handleSizeChange"
            :current-page.sync="dataProps.page_number"
            @current-change="$emit('navigateButton')"
            @prev-click="$emit('navigateButton')"
            @next-click="$emit('navigateButton')"
            :page-size.sync="limit"
            layout="total, sizes, prev, pager, next"
            :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
            :total="dataProps.total">
        </el-pagination>
  </div>
</template> 

<script>
export default {
    props: ['dataProps', 'hideTotal'],
    data() {
        return {
            limit: 0
        }
    },
    methods: {
        async handleSizeChange($val) {
            this.limit = parseInt($val)
            await this.$store.dispatch('updatePageLimit', {limit: this.limit})
           
            setTimeout(() => {
                this.$emit('navigateButton')    
            }, 1000);
            
        }
    },
    mounted() {
        this.limit = this.$store.getters.getDefaultPageLimit
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/GridPagination.vue